import React, { ChangeEvent } from 'react'
import { useFormikContext } from 'formik'
import tw from 'twin.macro'
import { RiskMinor } from '@shopify/polaris-icons'
import { MCNumberFormValues } from './MCNumberForm.interface'

interface MCNumberTextFieldProps {
  disabled?: boolean
}

export const MCNumberTextField = ({ disabled = false }: MCNumberTextFieldProps) => {
  const { values, setFieldValue, touched, errors } = useFormikContext<MCNumberFormValues>()

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(/\D/g, '')
    setFieldValue('mcNumber', inputValue)
  }

  const isTouched = touched.mcNumber
  const error = errors.mcNumber
  const value = String(values.mcNumber || '')

  return (
    <div css={tw`w-full`}>
      <div
        css={[
          tw`flex items-center w-full border border-solid border-shades-300 rounded-md px-3 py-2 bg-white text-base`,
          error ? tw`border-critical-500` : tw`border-shades-300`,
          isTouched && !error && value && tw`border-primary-500`,
        ]}
      >
        <span css={[tw`text-black font-medium mr-1 text-base`, disabled && tw`text-shades-200`]}>
          MC —{' '}
        </span>
        <input
          type="text"
          name="mcNumber"
          value={value}
          onChange={handleInputChange}
          placeholder="Enter Motor Carrier Number"
          css={[
            tw`flex-1 outline-none border-none bg-transparent text-base`,
            disabled && tw`text-shades-200`,
          ]}
          disabled={disabled}
          data-testid="contractors-onboarding-mc-number-input"
        />
      </div>
      {error && (
        <div css={tw`mt-1 text-critical-500 text-sm flex items-center gap-1`}>
          <RiskMinor width={20} css={tw`fill-critical-500`} />
          <span>{error}</span>
        </div>
      )}
    </div>
  )
}
